import { render, staticRenderFns } from "./AccountCheckIcon.vue?vue&type=template&id=0b4b8fe0"
import script from "./AccountCheckIcon.vue?vue&type=script&lang=js"
export * from "./AccountCheckIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports